import { useQuery } from "@tanstack/react-query";
import { fetchUserListByRegion } from "../../api/apiCallManager";

const useUserListByRegion = (region, role) => {
  return useQuery({
    queryKey: ["userListByRegion", region, role],
    queryFn: () => fetchUserListByRegion(region, role),
    enabled: !!region, // Only run the query if the region is provided
  });
};

export default useUserListByRegion;
